// extracted by mini-css-extract-plugin
export default {"book":"Book_book__MIDfJ","buttons":"Book_buttons__Ps-ys","category":"Book_category__Nsbk3"};